import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { forkJoin, Observable } from 'rxjs';
import { LoaderService } from './loader.service';
import { PanierState } from '../models';
import { FournisseurService } from './fournisseur.service';
import { PanierService } from './panier.service';

@Injectable({
  providedIn: 'root'
})
export class BalanceOutstandingResolver implements Resolve<any> {

  constructor(
    private loaderService: LoaderService,
    private fournisseurService: FournisseurService,
    private panierService: PanierService,
  ) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    this.loaderService.increaseLoaderCount();
    const supplierId = this.fournisseurService.getActiveSupplierId();
    if (this.panierService.getCartState() === PanierState.PAY_SUCCESS) {
      const fournisseursInfos$ = this.fournisseurService.fetchFournisseurs();
      const cartContent$ = this.panierService.fetchCart(supplierId);
      return forkJoin([fournisseursInfos$, cartContent$]);
    } else {
      return this.panierService.fetchCart(supplierId);
    }
  }
}
